import { createContext, useState } from 'react';
import {
    createUpdateFormData,
    createUpdateMultipleFields,
    createResetForm,
    getInitialFormData,
} from '../utils/companyFormUtils.js';

export const CompanyFormContext = createContext();

export const CompanyFormProvider = ({ children, initialData = {} }) => {
    const [formData, setFormData] = useState(getInitialFormData(initialData));
    const [initialFormData, setInitialFormData] = useState(
        getInitialFormData(initialData),
    );
    const [mode, setMode] = useState();
    const [deletedBillingNoteIDs, setDeletedBillingNoteIDs] = useState([]);
    const [residencyConfirmed, setResidencyConfirmed] = useState(false);
    const [engineLocationsError, setEngineLocationsError] = useState(null);

    const updateFormData = createUpdateFormData(setFormData);
    const updateMultipleFields = createUpdateMultipleFields(setFormData);
    const resetForm = createResetForm(setFormData, initialData);

    const value = {
        formData,
        setFormData,
        updateFormData,
        updateMultipleFields,
        resetForm,
        mode,
        setMode,
        initialFormData,
        setInitialFormData,
        deletedBillingNoteIDs,
        setDeletedBillingNoteIDs,
        residencyConfirmed,
        setResidencyConfirmed,
        engineLocationsError,
        setEngineLocationsError,
    };

    return (
        <CompanyFormContext.Provider value={value}>
            {children}
        </CompanyFormContext.Provider>
    );
};
